import styles from './ServicesFV.module.scss'
import Breadcrumb from 'components/common/Breadcrumb/Breadcrumb'
import { useRef } from 'react'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

interface Props {
  ServicesFVEach: {
    category: string
    title: string | JSX.Element
    text: string | JSX.Element
    imgSrc: string
    alt: string
  }
  paths: {
    name: string
    url: string
  }[]
}

const ServicesFV: React.FC<Props> = ({ ServicesFVEach, paths }) => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  return (
    <section
      className={`${styles.servicesFV} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <div className={styles.FVInner}>
        <div className={styles.FVText}>
          <Breadcrumb paths={paths} />
          <p className={styles.FVText__category}>{ServicesFVEach.category}</p>
          <h1 className={styles.FVText__title}>{ServicesFVEach.title}</h1>
          <p className={styles.FVText__text}>{ServicesFVEach.text}</p>
        </div>
      </div>
      <figure className={styles.FVImage}>
        <img src={ServicesFVEach.imgSrc} alt={ServicesFVEach.alt} width={710} height={328} />
      </figure>
    </section>
  )
}

export default ServicesFV
